import { getSimpleNumber } from './numbers';

export function getHours(seconds, decimalPoints = 2) {
  if (seconds === 0) {
    return 0;
  }
  if (!seconds) {
    throw new Error('Seconds is undefined.');
  }
  return getSimpleNumber(Number(seconds) / 3600, decimalPoints);
}
